export default {
  back: 'Continuer mes achats',
  disconnect: 'Me déconnecter',
  settings: 'Mon compte',
};
